import type { ChipModelDto } from '@/schemas/chip';

/**
 * Topological sort of chip DTOs so that dependency chips (leaves) come first.
 * This ensures that when deserializing, referenced chips are available before
 * the chips that contain them as instances.
 */
export function topologicalSortChipDtos(chipDtos: ChipModelDto[]): ChipModelDto[] {
  const chipDtoMap = new Map<string, ChipModelDto>();
  for (const dto of chipDtos) {
    chipDtoMap.set(dto.id, dto);
  }

  const sorted: ChipModelDto[] = [];
  const visited = new Set<string>();

  const visit = (dto: ChipModelDto) => {
    if (visited.has(dto.id)) return;
    visited.add(dto.id);
    for (const instanceDto of dto.chipInstanceDtos) {
      const dep = chipDtoMap.get(instanceDto.chipId);
      if (dep) visit(dep);
    }
    sorted.push(dto);
  };

  for (const dto of chipDtos) {
    visit(dto);
  }

  return sorted;
}
